import midasInstance from '@rsos/midas/src/midasInstance';
import { normalizePhoneNumber } from './normalizePhoneNumber';

const getRoadsideAssistanceLink = (phoneNumber, currentPsapAccountId = '') => {
  const response = async () => {
    try {
      const callflow = '/agero/swooplink';
      const numberWithPlus = normalizePhoneNumber(phoneNumber.value);
      const payload = {
        callflow,
        blocking: true,
        variables: {
          phone: numberWithPlus,
          ecc_id: currentPsapAccountId,
        },
      };

      return await midasInstance.post('/internal_auth/trigger', payload, {
        headers: { retry: true },
      });
    } catch (error) {
      return error;
    } finally {
      // do nothing
    }
  };
  return response();
};

export default getRoadsideAssistanceLink;
